import ActivityCard, { DefaultActivityContent } from "components/ActivityPanel/ActivityCard";
import React from "react";

interface Props {
  activity: server.dto.BankAccountActivity
}

export const BankAccountActivityCard = (props: Props) => {
  const { activity } = props;
  const { action } = activity;

  const isAccountNumberType = action.value === "modifyAbaRoutingNumber"
    || action.value === "modifyInstitutionNumber"
    || action.value === "modifyAccountNumber"
    || action.value === "modifyTransitNumber"
    || action.value === "modifyBsbCode"
    || action.value === "modifyIbanNumber"
    || action.value === "modifySwiftCode";

  return <ActivityCard
    activity={activity}
  >
    <DefaultActivityContent
      contentStyle={isAccountNumberType ? { wordBreak: "break-all" } : undefined}
      activity={props.activity}
    />
  </ActivityCard>
}